// Настройки системы: то, что заказчик меняет сам.
//
// Значения приходят СТРОКАМИ, а рядом — вид (int, money, bool, string). Разложить их по типам
// на клиенте значило бы завести второе место, где живёт знание «эта настройка булева», и оно
// разъедется с сервером на первой же новой настройке.

import { request } from '@/shared/api/client';
import type { ListResponse } from '@/shared/api/types';

export interface SettingOut {
  key: string;
  value: string;
  /** int, money, bool, string: по нему экран выбирает орган управления. */
  value_kind: string;
  title: string;
  /** Зачем настройка нужна и чем грозит её смена. Для человека, а не для кода. */
  description?: string | null;
  /**
   * Закрытый список значений: код и как он называется человеку.
   *
   * Пусто — значение свободное (число, сумма, переключатель). Пока списка не было, экран
   * показывал человеку наш код («accepted», «reduce_debt») прямо в поле ввода и принимал в
   * него что угодно: опечатка молча меняла поведение расчёта.
   */
  options?: SettingOptionOut[];
}

/** Один вариант значения настройки. */
export interface SettingOptionOut {
  value: string;
  title: string;
}

export function fetchSettings(): Promise<ListResponse<SettingOut>> {
  return request<ListResponse<SettingOut>>('/api/v1/settings');
}

export function setSetting(key: string, value: string): Promise<SettingOut> {
  return request<SettingOut>(`/api/v1/settings/${encodeURIComponent(key)}`, {
    method: 'PATCH',
    body: { value },
  });
}
